import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { t } from '@/i18n';
import { axios } from '@/lib/utils/axios';
import { getResponse, toastApiError } from '../common';
import { API_URLS, queryClient } from '../query.client';

export type UpdateUserSuccessResponseType = { message: string };
export type UpdateUserPayload = Partial<{
	email: string;
	firstName: string;
	lastName: string;
	groups: string[];
	organizations: string[];
	password: string;
	enabled: boolean;
}>;

async function updateUser(id: string, payload: UpdateUserPayload): Promise<UpdateUserSuccessResponseType | null> {
	const response = await axios.patch(`${API_URLS.USERS.INDEX}/${id}`, payload);
	return getResponse<UpdateUserSuccessResponseType>(response.data);
}

export type UpdateUserPayloadType = {
	id: string;
	payload: UpdateUserPayload;
};

export function updateUserOptions() {
	return mutationOptions({
		mutationFn: ({ id, payload }: UpdateUserPayloadType) => updateUser(id, payload),
		onSuccess: async (data) => {
			console.log('User updated successfully:', data);
			toast.success(t('admin.toast.userUpdated'));
			await queryClient.invalidateQueries({ queryKey: ['users'] });
		},
		onError: (error) => toastApiError(error),
	});
}
